<template>
  <div>
    <card shadow type="secondary">
      <div class="col-12">
        <div class="row">
          <h6 class="heading-small text-muted mb-4 pl-2">
            <i class="fas fa-clipboard-list mr-1"></i> Histórico de submissões
          </h6>
        </div>
        <div v-if="empty" class="col-12 text-center mt--3">
          <badge type="info">Não há tarefas no histórico</badge>
        </div>
        <div class="row vld-parent" ref="list_past_tasks">
          <div
            class="col-lg-4 col-md-6"
            v-for="task in pastTasks"
            :key="'task_' + task.id"
            @click="handleViewTask(task.batch_id, task.id)"
          >
            <span title="Ver tarefa" class="task-card pb-1 shadow">
              <div class="mb-3 task-card-header">
                <i
                  :class="[
                    task.responses.length
                      ? 'text-success fas fa-clipboard-check'
                      : 'text-danger fas fa-clipboard',
                  ]"
                ></i>
                <span :title="task.title">{{ task.title }}</span>
              </div>
              <span class="float-right text-sm text-muted" v-if="task.deadline"
                ><i class="far fa-calendar-alt mr-1"></i> até
                {{ formatDate(task.deadline, "L") }}</span
              >
              <span class="float-right text-sm text-muted" v-else
                ><i class="far fa-calendar-alt mr-1"></i> sem prazo</span
              >
            </span>
          </div>
          <div
            class="col-12 pr-0 text-right"
            v-if="pastTasks.length === initialLimit"
          >
            <base-button type="link" :custom="true" @click="loadPastTasks()"
              >Carregar todas tarefas do histórico</base-button
            >
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "open-tasks",
  props: {
    batchId: {
      type: Number,
      required: true,
      description: "Batch identifier",
    },
  },
  data() {
    return {
      pastTasks: [],
      initialLimit: 9,
      empty: "",
    };
  },
  async mounted() {
    await this.loadPastTasks(this.initialLimit);
  },
  methods: {
    handleViewTask(batchId, taskId) {
      this.$router.push(
        `/startup/batches/${batchId}/acompanhamento/tasks/${taskId}/visualizar`
      );
    },
    async loadPastTasks(limit = "") {
      const loaderpastTasks = this.$loading.show({
        container: this.$refs.list_past_tasks,
        width: 90,
        height: 90,
      });
      try {
        const limitStr = `&limit=${limit}`;
        const { data: pastTasks } = await api.get(
          `/startup-batches/${this.batchId}/tasks?filter=past${
            limit ? limitStr : ""
          }`
        );
        if (!pastTasks.length) this.empty = true;
        this.pastTasks = pastTasks;
        loaderpastTasks.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar o histórico de tarefas"
        );
        this.$router.push(`/startup/batches`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.2rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: flex;
  }

  .task-card-header i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: middle;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}
</style>
